import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path} from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function TouchIdIcon(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (

    <Svg
      {...svgProps}
      viewBox="0 0 36.164 36.164">
      <G fill={color}>
        <Path d="M10.296,26.25V3.214h14.607V21h1.409V2.026C26.312,0.912,25.401,0,24.286,0H10.913C9.798,0,8.886,0.912,8.886,2.026v25.949   c0,1.113,0.912,2.024,2.027,2.024h3.628l-2-3.75L10.296,26.25L10.296,26.25z M15.46,1.461h4.279c0.135,0,0.244,0.109,0.244,0.246   c0,0.135-0.109,0.244-0.244,0.244H15.46c-0.135,0-0.246-0.109-0.246-0.244C15.214,1.57,15.326,1.461,15.46,1.461z M27.278,23.741   v-0.25c0-0.558-0.453-1.013-1.014-1.013h-0.107c-0.562,0-1.014,0.455-1.014,1.012v0.251v0.891h-0.391v-0.891V23.49   c0-0.557-0.452-1.012-1.012-1.012h-0.11c-0.558,0-1.013,0.455-1.013,1.012v1.142h-0.391V23.49c0-0.557-0.453-1.012-1.012-1.012   h-0.109c-0.561,0-1.013,0.455-1.013,1.012v0.251v0.891h-0.323v-2.675c2.09-0.541,3.646-2.426,3.646-4.682   c0-2.678-2.178-4.855-4.854-4.855c-2.676,0-4.854,2.178-4.854,4.855c0,2.354,1.687,4.318,3.914,4.758v2.602v1.204v2.433   c-1.08-1.151-1.733-2.434-2.432-2.594c-0.903-0.209-1.665,0.485-1.041,1.689c0.625,1.203,3.615,6.425,3.619,6.431   c0.396,0.96,1.67,2.367,4.68,2.366c4.828,0.001,4.828-4.307,4.828-4.307v-6.219c0-0.004,0.002-0.006,0.002-0.01V23.741   L27.278,23.741z M18.752,16.996l-0.11-0.001c-0.563,0-1.019,0.456-1.019,1.021v1.123c-0.683-0.347-1.156-1.047-1.156-1.863   c0-1.155,0.94-2.096,2.096-2.096c1.156,0,2.097,0.94,2.097,2.096c0,0.704-0.354,1.326-0.887,1.705v-0.965   C19.772,17.451,19.317,16.995,18.752,16.996z M14.209,17.275c0-2.401,1.953-4.355,4.354-4.355c2.401,0,4.354,1.954,4.354,4.355   c0,1.979-1.336,3.633-3.146,4.161v-1.312c1.107-0.473,1.887-1.571,1.887-2.849c0-1.707-1.389-3.096-3.096-3.096   c-1.707,0-3.096,1.389-3.096,3.096c0,1.376,0.91,2.533,2.156,2.934v1.312C15.674,21.088,14.209,19.352,14.209,17.275z" fill={color}/>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
      <G>
      </G>
    </Svg>

  );
}

TouchIdIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

TouchIdIcon.defaultProps = {
  height: 120,
  width: 120,
};

export default pure(TouchIdIcon);
